import React from "react";
import { CgPlayListRemove } from "react-icons/cg";
import { AiOutlineCheck } from "react-icons/ai";

const DetalhamentoModeloImportacao = ({ data }) => {
  console.log("Dados: ", data);

  if (data.ocorrenciasModeloImportacao.length > 0) {
    return (
      <div className="text-left m-4">
        <h5>Ocorrências que usam o modelo:</h5>
        <ul className="list-group">
          {data.ocorrenciasModeloImportacao.map((item) => (
            <li className="list-group-item py-4" key={item.sequenceTipoOcorrencia}>
              <AiOutlineCheck className="text-success" /> <strong>{item.sequenceTipoOcorrencia}</strong> -{" "}
              {item.descricaoTipoOcorrencia}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="text-center m-4">
      {" "}
      <CgPlayListRemove className="text-danger" /> <span className="text-muted">Sem atividades associadas</span>
    </div>
  );
};

export default DetalhamentoModeloImportacao;
